<main>
    <h1>Ihre Registrierung war erfolgreich.</h1>
    <p>Sie können jetzt einer bestehenden Organisation beitreten oder eine neue Organisation anlegen.</p>
    <div>
        <button (click)="routeToMarketplace()" matButton="elevated" color="warn">
            Zurück zur Startseite
        </button>
        <button matButton="elevated" color="accent" [routerLink]="['/profil/mitgliedschaften']" [queryParams]="{ mode: 'join' }">
            Organisation beitreten
        </button>
        <button matButton="elevated" class="green-confirm" [routerLink]="['/profil/mitgliedschaften']" [queryParams]="{ mode: 'create' }">
            Neue Organisation erstellen
        </button>
    </div>
</main>
